export const titleText = "You are welcomed to sacrifice an NFT"
export const subtitleText = "Select one of your qualified NFTs"
export const ctaOneText = "Proceed to Temple"
export const ctaTwoText = "Back"
